import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { API, axios } from '../utils/api';
import Icona from '../components/cliente/Icone';
import { Logo } from './staff/Agenzie';
import '../components/staff/scheda.css';
import '../components/staff/impostazioni.css';

// /admin/agenzie/doppioni (Agenzie → "Possibili doppioni"), nello stile delle pagine dello staff: le coppie di agenzie
// che potrebbero essere la stessa (stesso telefono, stesso id su un portale, stesso nome nello stesso comune). Mai unite
// da sole: l'admin vede prima cosa succede ("Unisci, tieni …" con l'anteprima) oppure "Tieni separate".
// Rotte: backend/rotte_agenzie.py (GET /doppioni-agenzie, POST …/cerca, …/{id}/unisci {tieni}, …/{id}/separa).

const SchedaDoppione = ({ a }) => (
  <div className="doppione-agenzia" data-testid={`doppione-${a.id}`}>
    <Logo a={a} />
    <div style={{ minWidth: 0 }}>
      <Link className="nome-link" to={`/admin/agenzie/${a.id}`}>{a.etichetta || a.nome}</Link>
      <span>{[a.telefono, a.comune, ...Object.entries(a.id_portale || {}).map(([p, v]) => `${p}: ${v}`)].filter(Boolean).join(' · ') || 'nessun contatto'}</span>
      <span>{a.immobili} {a.immobili === 1 ? 'immobile' : 'immobili'} · {a.clienti} {a.clienti === 1 ? 'cliente' : 'clienti'}{(a.esempi || []).length ? ` · ${a.esempi.join(', ')}` : ''}</span>
    </div>
  </div>
);

const DoppioniAgenzie = () => {
  const [coppie, setCoppie] = useState(null);
  const [errore, setErrore] = useState(false);
  const [attesa, setAttesa] = useState(null);
  // Come per le pratiche: un server che non risponde non è «nessun doppione». Prima `catch(() => setCoppie([]))`
  // faceva leggere «Nessun doppione da decidere» anche quando non si era letto niente (blocco 4, primo giro).
  const carica = useCallback(() => axios.get(`${API}/doppioni-agenzie`)
    .then((r) => { setErrore(false); setCoppie(r.data); })
    .catch(() => { setCoppie(null); setErrore(true); }), []);
  useEffect(() => { carica(); }, [carica]);
  const cerca = async () => {
    setAttesa('cerca');
    try {
      const r = await axios.post(`${API}/doppioni-agenzie/cerca`);
      const n = r.data.nuove;
      toast.success(n ? (n === 1 ? '1 coppia nuova da decidere' : `${n} coppie nuove da decidere`) : 'Nessuna coppia nuova');
      carica();
    } catch { toast.error('Ricerca non riuscita'); } finally { setAttesa(null); }
  };
  const decidi = async (coppia, tieni) => {
    setAttesa(coppia.id);
    try {
      if (tieni) {
        const r = await axios.post(`${API}/doppioni-agenzie/${coppia.id}/unisci`, { tieni });
        toast.success(`Unite: resta ${r.data.agenzia}`);
      } else {
        await axios.post(`${API}/doppioni-agenzie/${coppia.id}/separa`);
        toast.success('Restano due agenzie: la coppia non torna più');
      }
      carica();
    } catch (e) { toast.error(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'Non riuscito'); } finally { setAttesa(null); }
  };
  return (
    <main className="st wrap" data-testid="doppioni-agenzie">
      <Link className="back" to="/admin/agenzie"><Icona nome="indietro" />Agenzie</Link>
      <div className="imp-head">
        <div><div className="k">Agenzie</div><h1>Possibili doppioni{coppie ? <>, <em>{coppie.length} da decidere</em></> : null}</h1>
          <p>Stesso marchio in un altro comune non è un doppione. Qui solo le coppie da guardare: unite (vedete prima cosa succede) o tenete separate.</p></div>
        <button type="button" className="btn" onClick={cerca} disabled={attesa === 'cerca'}>{attesa === 'cerca' ? 'Cerco…' : 'Cerca di nuovo'}</button>
      </div>
      {!coppie && !errore && <p className="vuoto">Carico le coppie…</p>}
      {errore && (
        <section className="card"><p className="vuoto" role="alert" data-testid="doppioni-errore">
          Non riesco a caricare i possibili doppioni. Riprovate tra poco.
        </p></section>
      )}
      {coppie && !coppie.length && <section className="card"><p className="vuoto">Nessun doppione da decidere.</p></section>}
      <div className="imp-griglia">
        {(coppie || []).map((c) => (
          <section key={c.id} className="card" data-testid={`coppia-${c.id}`}>
            <div className="ttl"><div className="i w"><Icona nome="edificio" /></div><h2>Sono la stessa agenzia?</h2><span className="tag t-w">{c.motivo}</span></div>
            <div className="doppioni-coppia">{c.agenzie.map((a) => <SchedaDoppione key={a.id} a={a} />)}</div>
            <div className="imp-righe" style={{ marginTop: '1rem' }}>
              {c.agenzie.map((a) => (
                <div key={a.id}>
                  <button type="button" className="btn sm p" disabled={attesa === c.id} onClick={() => decidi(c, a.id)}>Unisci, tieni {a.etichetta || a.nome}</button>
                  <span className="descr">{c.anteprima?.[a.id]}</span>
                </div>
              ))}
              <div><button type="button" className="btn sm" disabled={attesa === c.id} onClick={() => decidi(c, null)}>Tieni separate</button>
                <span className="descr">Restano due agenzie e la coppia non viene più proposta.</span></div>
            </div>
          </section>
        ))}
      </div>
    </main>
  );
};

export default DoppioniAgenzie;
